export const domainUrl = (window as any)?.ENV_CONFIG?.API_URL;
export const minIoUrl = (window as any)?.ENV_CONFIG?.MINIO_URL;
// export const domainUrl = "https://erp.rasoft.az/app/";
// export const minIoUrl = "https://minio.rasoft.az/";

//microservice name
export const erpService = 'erp-service/';
export const ratechEnumService = `${erpService}Enums/getByName/`;
const erpServiceEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.api.enums`;
const erpServiceCoreEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.data.enums`;
const coreServiceEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.data.enums`;
const coreSharedEnumRoot = `${erpService}Enums/getByName/com.ratech.erp.core.shared.enums`;

export const apiUrl = {
    yonetim: {
        application: `${erpService}Management/Application/`,
        barcodeTemplate: `${erpService}Management/BarcodeTemplate/`,
        dil: `${erpService}Management/Localization/`,
        eMailApi: `${erpService}Management/EMailApi/`,
        eyalet: `${erpService}Management/State/`,
        il: `${erpService}Management/Province/`,
        ilce: `${erpService}Management/District/`,
        kimlik: `${erpService}Management/Identity/`,
        organization: `${erpService}Management/Organization/`,
        bina: `${erpService}Management/Organization/Facility/`,
        roleGroup: `${erpService}Management/RoleGroup/`,
        smsApi: `${erpService}Management/SmsApi/`,
        tools: `${erpService}Management/Tools/`,
        ulke: `${erpService}Management/Country/`,
        kullanici: `${erpService}Management/User/`,
        kullaniciYetki: `${erpService}Management/UserPermission/`,
        kullaniciVeriYetki: `${erpService}Management/UserEntryPermission/`,
        system: `${erpService}Management/System/`,
        veriYetki: `${erpService}Management/UserEntryPermission/`,
        translation: `${erpService}Management/Translation/`,
        report: `${erpService}Management/Report/`,
        reportDesign: `${erpService}Management/ReportDesign/`,
        reportDesignDetail: `${erpService}Management/ReportDesign/Detail/`,
        reportDesignParameter: `${erpService}Management/ReportDesign/Parameter/`,
        reportDesignField: `${erpService}Management/ReportDesign/Field/`,
        reportDesignFile: `${erpService}Management/ReportDesignFile/`,
        dynamicQueryGroup: `${erpService}Management/DynamicQueryGroup/`,
        dynamicQuery: `${erpService}Management/DynamicQuery/`,
        dynamicQueryField: `${erpService}Management/DynamicQuery/Field/`,
        dynamicQueryCriteria: `${erpService}Management/DynamicQuery/Criteria/`,
        printer: `${erpService}Management/Printer/`,
        attachment: `Management/Attachment/`,
        userMessage: `${erpService}Management/UserMessage/`,
        printLog: `${erpService}Management/PrintLog/`,
        serverProgress: `${erpService}Management/ProcessProgress/`,
        systemParameter: `${erpService}Management/SystemParameter/`,
        exchangeRate: `${erpService}Management/ExchangeRate/`,


    },
    tanimlar: {
        birim: `${erpService}Tanim/Birim/`,
        proje: `${erpService}Tanim/Proje/`,
        eFaturaAyar: `${erpService}Tanim/EFaturaAyar/`,
        kimlik: `${erpService}Kimlik/`,
        kurum: `${erpService}Tanim/Kurum/`,
        kurumGrup: `${erpService}Tanim/Kurum/Grup/`,
        personel: `${erpService}Tanim/Personel/`,
        personelUnvan: `${erpService}Tanim/Unvan/`,
        personelMezuniyet: `${erpService}Tanim/Personel/Mezuniyet/`,
        sablon: `${erpService}Tanim/Sablon/`,
        kalemTuru: `${erpService}Tanim/KalemTuru/`,
        kasaOturum: `${erpService}Satis/KasaOturum/`,
        marka: `${erpService}Tanim/Marka/`,
        olcuBirim: `${erpService}Tanim/OlcuBirim/`,
        kalem: `${erpService}Tanim/Kalem/`,
        anlasma: `${erpService}Tanim/Anlasma/`,
        anlasmaDetay: `${erpService}Tanim/AnlasmaDetay/`,
        eFaturaMuafiyet: `${erpService}Tanim/EFaturaMuafiyet/`,
        eFaturaTevkifat: `${erpService}Tanim/EFaturaTevkifat/`,
        kurumFaturaParametre: `${erpService}Tanim/KurumFaturaParametre/`,
        hesapPlan: `${erpService}Tanim/HesapPlan/`,
        hesapPlanDonem: `${erpService}Tanim/HesapPlanDonem/`,
        bolge: `${erpService}Tanim/Bolge/Bolge/`,
        masa: `${erpService}Tanim/Bolge/Masa/`
    },
    ihale: {
        kayit: `${erpService}Ihale/`,
        kalem: `${erpService}Ihale/Kalem/`,
        evrak: `${erpService}Ihale/Evrak/`,
        tedarikci: `${erpService}Ihale/Tedarikci/`,
        tedarikciKalem: `${erpService}Ihale/TedarikciKalem/`,
        ihaleTeklif: `${erpService}Ihale/Teklif/`,
        ihaleTeklifKalem: `${erpService}Ihale/TeklifKalem/`,
        topluAlimKurum: `${erpService}Ihale/TopluAlimKurum/`,
        topluAlimKurumKalem: `${erpService}Ihale/TopluAlimKurumKalem/`,
    },
    siparis: {
        kayit: `${erpService}Siparis/`,
        kalem: `${erpService}Siparis/Kalem/`,
    },
    satis: {
        satis: `${erpService}Satis/Satis/`,
        satisDetay: `${erpService}Satis/SatisDetay/`,
    },
    dashboard: {
        dashboard: `${erpService}Dashboard/`,
    },

    auth: {
        userLogin: `${erpService}Auth/UserLogin/`,
    },

    stok: {
        barkodTakip: `${erpService}Stok/BarkodTakip/`,
        hareketBarkod: `${erpService}Stok/HareketBarkod/`,
        tanimlar: {
            etkenMadde: `${erpService}Tanim/Stok/EtkenMadde/`,
            malzemeOlcuBirim: `${erpService}Tanim/Stok/MalzemeOlcuBirim/`,
            olcuBirim: `${erpService}Tanim/OlcuBirim/`,
            malzemeDepoDetay: `${erpService}Tanim/Stok/MalzemeDepoDetay/`,
        },
        stokHareket: `${erpService}Stok/StokHareket/`,
        stokHareketDetay: `${erpService}Stok/StokHareketDetay/`,
        stokHareketDosya: `${erpService}Stok/StokHareket/Dosya/`,
        stokTalep: `${erpService}Stok/StokTalep/`,
        stokTalepDetay: `${erpService}Stok/StokTalepDetay/`,
        stokAtik: `${erpService}Stok/StokAtik/`,
        stokIade: `${erpService}Stok/StokIade/`,
        malzemeDepoDurum: `${erpService}Stok/MalzemeDepoDurum/`,
    },

    fatura: {
        fatura: `${erpService}Fatura/`,
        faturaDetay: `${erpService}Fatura/Detay/`,
        gelenEFatura: `${erpService}EFatura/`,
        cariBelge: `${erpService}Fatura/CariBelge/`,
        barkod: `${erpService}Fatura/Barkod/`,
    },

    muhasebe: {
        muhasebeHareket: `${erpService}MuhasebeHareket/`,
        muhasebeHareketDetay: `${erpService}MuhasebeHareket/Detay/`,
        cariHareket: `${erpService}Muhasebe/CariHareket/`,
        kasaBanka: `${erpService}Muhasebe/KasaBanka/`,
        cekSenet: `${erpService}Muhasebe/CekSenet/`,
        cekSenetHareket: `${erpService}Muhasebe/CekSenetHareket/`,
        rapor: `${erpService}Muhasebe/Rapor/`,
    },

    iletisim: {
        tanimlar: {
            interaktifSablon: `${erpService}Iletisim/Tanim/InteraktifSablon/`,
            interaktifSablonDetay: `${erpService}Iletisim/Tanim/InteraktifSablon/Detay/`,
        }
    },

    klinikMuhendislik: {
        cihaz: {
            tanimlar: {
                cihaz: `${erpService}KlinikMuhendislik/Tanim/Cihaz/`,
            },
            cihazDosya: `${erpService}KlinikMuhendislik/Cihaz/CihazDosya/`,
            cihazBakim: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/`,
            cihazBakimPeriyot: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/Periyot/`,
            cihazBakimDosya: `${erpService}KlinikMuhendislik/Cihaz/CihazBakimDosya/`,
            cihazZimmet: `${erpService}KlinikMuhendislik/Cihaz/Zimmet/`,
            cihazBakimPeriyotMalzeme: `${erpService}KlinikMuhendislik/Cihaz/CihazBakim/Periyot/Malzeme/`,
        },
        destek: {
            destekTalep: `${erpService}KlinikMuhendislik/DestekTalep/`,
            destekTalepYorum: `${erpService}KlinikMuhendislik/DestekTalep/Yorum/`,
            destekTalepCalisma: `${erpService}KlinikMuhendislik/DestekTalep/Calisma/`,
        }
    },

    restoran: {
        base: `${erpService}Tanim/Bolge/Masa/`,
    },

    enums: {
        kalemGrubu: `${erpServiceEnumRoot}.KalemGrubu`,
        kalemAltGrubu: `${erpServiceEnumRoot}.KalemAltGrubu`,
        kurumTuru: `${erpServiceEnumRoot}.KurumTuru`,
        cariBelgeTuru: `${erpServiceEnumRoot}.CariBelgeTuru`,
        birimGrubu: `${erpServiceEnumRoot}.BirimGrubu`,
        birimAltGrubu: `${erpServiceEnumRoot}.BirimAltGrubu`,
        malzemeTuru: `${erpServiceEnumRoot}.MalzemeTuru`,
        malzemeOlcuBirimTipi: `${erpServiceEnumRoot}.MalzemeolcuBirimTipi`,
        malzemeSatisTipi: `${erpServiceEnumRoot}.MalzemeSatisTipi`,
        kurumTipi: `${erpServiceEnumRoot}.KurumTipi`,
        stokSatisHedefi: `${erpServiceEnumRoot}.StokSatisHedefi`,
        belgeTipi: `${erpServiceEnumRoot}.BelgeTipi`,
        malHizmetGorunumTipi: `${erpServiceEnumRoot}.MalHizmetGorunumTipi`,
        kurumSeriTipi: `${erpServiceEnumRoot}.KurumSeriTipi`,
        faturaKayitTipi: `${erpServiceEnumRoot}.FaturaKayitTipi`,
        faturaDurum: `${erpServiceEnumRoot}.FaturaDurum`,
        eFaturaSenaryo: `${erpServiceEnumRoot}.EFaturaSenaryo`,
        eFaturaTipi: `${erpServiceEnumRoot}.EFaturaTipi`,
        eFaturaDurum: `${erpServiceEnumRoot}.EFaturaDurum`,
        eFaturaIntegrationProvider: `${erpServiceEnumRoot}.EFaturaIntegrationProvider`,
        stokHareketSekli: `${erpServiceEnumRoot}.StokHareketSekli`,
        stokKayitDurumu: `${erpServiceEnumRoot}.StokHareketKayitDurumu`,
        stokTalepDurumu: `${erpServiceEnumRoot}.StokTalepDurumu`,
        ihaleDurumu: `${erpServiceEnumRoot}.IhaleDurumu`,
        ihaleAlimYontemi: `${erpServiceEnumRoot}.IhaleAlimYontemi`,
        ihaleTuru: `${erpServiceEnumRoot}.IhaleTuru`,
        ihaleEvrakTuru: `${erpServiceEnumRoot}.IhaleEvrakTuru`,
        ihaleHakedisYontemi: `${erpServiceEnumRoot}.IhaleHakedisYontemi`,
        ihaleTedarikciDurum: `${erpServiceEnumRoot}.IhaleTedarikciDurum`,
        ihaleTeklifTuru: `${erpServiceEnumRoot}.IhaleTeklifTuru`,
        hesapPlanKategori: `${erpServiceEnumRoot}.HesapPlanKategori`,

        //Core Enums
        requestType: `${coreServiceEnumRoot}.SmsRequestType`,
        responseType: `${coreServiceEnumRoot}.SmsResponseType`,
        barkodSablonTipi: `${coreServiceEnumRoot}.BarkodSablonTipi`,
        cinsiyet: `${coreServiceEnumRoot}.Gender`,
        printerType: `${coreServiceEnumRoot}.PrinterType`,
        barcodeCommandType: `${coreSharedEnumRoot}.BarcodeCommandType`,
        printMethod: `${coreServiceEnumRoot}.PrintMethod`,
        medeniDurum: `${coreServiceEnumRoot}.MaritalStatus`,
        httpMethod: `${coreServiceEnumRoot}.HttpMethod`,
        status: `${coreServiceEnumRoot}.Status`,
        userRole: `${coreServiceEnumRoot}.UserRole`,
        varYok: `${erpServiceEnumRoot}.VarYok`,
        yesNo: `${coreServiceEnumRoot}.YesNo`,
        reportParameterType: `${coreServiceEnumRoot}.ReportParameterType`,
        reportDesignFileType: `${coreServiceEnumRoot}.ReportDesignFileType`,
        color: `${coreServiceEnumRoot}.Color`,
        dynamicQueryFieldType: `${coreServiceEnumRoot}.DynamicQueryFieldType`,
        organizationLevel: `${coreServiceEnumRoot}.OrganizationLevel`,
        parameterValueSource: `${coreServiceEnumRoot}.ParameterValueSource`,
        weekDay: `${coreServiceEnumRoot}.WeekDay`,
        currency: `${coreServiceEnumRoot}.Currency`,
        siparisTipi: `${erpServiceEnumRoot}.SiparisTipi`,
        siparisDurumu: `${erpServiceEnumRoot}.SiparisDurumu`,
        stokHareketTipi: `${erpServiceEnumRoot}.StokHareketTipi`,
        muhasebeHareketSekli: `${erpServiceEnumRoot}.MuhasebeHareketSekli`,
        odemeSekli: `${erpServiceEnumRoot}.OdemeSekli`,
        cariHareketTipi: `${erpServiceEnumRoot}.CariHareketTipi`,
        cariHareketKaynakTipi: `${erpServiceEnumRoot}.CariHareketKaynakTipi`,
        finansIslemTipi: `${erpServiceEnumRoot}.FinansIslemTipi`,
        cekSenetTipi: `${erpServiceEnumRoot}.CekSenetTipi`,
        cekSenetYonu: `${erpServiceEnumRoot}.CekSenetYonu`,
        cekSenetDurumu: `${erpServiceEnumRoot}.CekSenetDurumu`,
        muhasebeHareketTipi: `${erpServiceEnumRoot}.MuhasebeHareketTipi`,
        emailSmsSablonTipi: `${coreServiceEnumRoot}.EMailSmsSablonTipi`,
        interaktifMesajTipi: `${coreServiceEnumRoot}.InteraktifMesajTipi`,
        interaktifGonderimTipi: `${coreServiceEnumRoot}.InteraktifGonderimTipi`,
        cihazDurumu: `${erpServiceEnumRoot}.CihazDurumu`,
        cihazZimmetDurumu: `${erpServiceEnumRoot}.CihazZimmetDurumu`,
        malzemeUcretDurumu: `${erpServiceEnumRoot}.MalzemeUcretDurumu`,
        cihazTipi: `${erpServiceEnumRoot}.CihazTipi`,
        sureTipi: `${erpServiceEnumRoot}.SureTipi`,
        tahsilatSekli: `${erpServiceEnumRoot}.TahsilatSekli`,
        sterilizasyonTuru: `${erpServiceEnumRoot}.SterilizasyonTuru`,
        destekTalepDurumu: `${erpServiceEnumRoot}.DestekTalepDurumu`,
        destekTipi: `${erpServiceEnumRoot}.DestekTipi`,
        oncelikDurumu: `${erpServiceEnumRoot}.OncelikDurumu`,
        destekTuru: `${erpServiceEnumRoot}.DestekTuru`,


    }
}
